export default {
  setUsers (state, payload) {
    state.users = payload
  },
  set_all_interviews (state, payload) {
    state.all_interviews = payload
  }
}
